// Generated by CoffeeScript 1.12.7

/**
Converts a URL string into its separate parts

@method parseUrl
@param {String} url the url to parse
@return {Object}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/parse_url',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.parseUrl = factory();
  }
})(this, function() {
  var parseUrl;
  return parseUrl = function(url) {
    var parser;
    url = url || location;
    parser = document.createElement('a');
    parser.href = url;
    return {
      protocol: parser.protocol.replace(":", ""),
      hostname: parser.hostname,
      port: parser.port,
      pathname: parser.pathname,
      search: parser.search,
      hash: parser.hash,
      host: parser.host
    };
  };
});

